import React from 'react';
import { FormattedMessage } from 'react-intl';

import Text from '../Text';
import { DynamicContainer } from '../Layout';

function ErrorCard({ error, children }) {
    if (!error) {
        return <>{children}</>;
    }
    return (
        <DynamicContainer isFluid>
            <Text>
                <FormattedMessage id="jobPage.fetch.error" />
            </Text>
        </DynamicContainer>
    );
}

ErrorCard.defaultProps = {
    message: null,
};

export default ErrorCard;
